<template>
    <div
        class="gcmcn-card gcmcn-card-dashboard"
        style="padding: 0;"
    >
        <event
            :event="event"
            :selectedEventUid="selectedEventUid"
            :universe="universe"
            :condensed="condensed"
            style="padding-bottom: 0;"
            @changeSelectedEvent="$emit('changeSelectedEvent', $event)"
        ></event>
        <div class="dashboard-see-more" @click="showEvent">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>

import Event from '../Events/eventCard.vue';
export default {

    components: {
        Event,
    },

    props: {
        event: {
            type: Object,
            required: true
        },
        selectedEventUid: {
            type: String,
            required: true
        },
        universe: {
            type: Object,
            required: true
        },
        condensed: {
            type: Boolean,
            default: false
        }

    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        showEvent (){
            this.$router.push({
                name: 'events',
                params: {
                    eventUid: this.event.uid,
                },
            });
        }
    },
};
</script>

<style lang="scss">
.event-card.gcmcn-card.selected-element + .dashboard-see-more{
    background-color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/event-card.vue